import React, { Component } from "react";
import { connect } from "react-redux";
import {
  PageHeader,
  Spin,
  Descriptions,
  Divider,
  Row,
  Col,
  Space,
  Button,
  Card,
  Tag,
  Typography,
  List,
  message,
  Empty,
  Tooltip,
  Tabs,
} from "antd";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  HistoryOutlined,
  CalculatorOutlined,
  RollbackOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import axios from "axios";
import SelectInsumosItem from "../../../Components/SelectInsumosItem";
import EtiquetaMoneda from "../../../Components/EtiquetaMoneda";
import {
  dineroDisabledMask,
  InputNumberItem,
  round2Decimals,
} from "../../../Components/Items";
import { normalizarAtajosPorcentaje } from "../../../Utils/reglasPrecio";

const { TabPane } = Tabs;
const { Text, Title } = Typography;

class CotizadorPorInsumo extends Component {
  state = {
    loading: false,
    insumoId: undefined,

    descripcion: "",
    descripcionLarga: "",
    unidad: "",
    costo: 0,
    // Abreviacion de Insumo.monedaId: el costo, los precios y el historial estan en ESA
    // moneda, no necesariamente en pesos. Solo se rotula, no se convierte nada.
    moneda: "MXN",
    impuestos: [],

    calcularPreciosSobre: false,
    // Atajos de la calculadora; vacio = los de por defecto
    atajosPorcentaje: [],
    porcentaje: 0,

    // Totales
    costoImpuestos: 0,
    totalImpuestosPrecio: 0,
    totalImpuestosCosto: 0,
    precioCalculado: 0,
    precioCalculadoConImpuestos: 0,
    porcentajeLista: 0,

    //Lista de precios
    listaDePrecios: [],
    verListaPrecios: true,
    //Historial de costos
    historialCostos: [],
    verHistorialCostos: false,

    costoOriginal: 0,
    fechaCostoSeleccionado: null,

    // Existencias
    loadingExistencias : false, 
    existencias : [],
    verExistencias : false, 
    totalExistencias : 0, 
  };

  atras() {
    this.props.history.goBack();
  }

  handleInsumoChange = (value) => {
    this.setState({ insumoId: value }, () => {
      if (value) {
        this.consultarInsumo(value);
        this.consultarPrecios();
      } else {
        this.limpiarDatos();
      }
    });
  };

  limpiarDatos = () => {
    this.setState({
      descripcion: "",
      descripcionLarga: "",
      unidad: "",
      costo: 0,
      costoOriginal: 0,
      precioLista: 0,
      impuestos: [],
      precioListaImpuestos: 0,
      costoImpuestos: 0,
      precioCalculado: 0,
      precioCalculadoConImpuestos: 0,
      listaDePrecios: [],
      verListaPrecios: true,
      historialCostos: [],
      verHistorialCostos: false,
      fechaCostoSeleccionado: null,
      existencias : [],
      verExistencias : false, 
      totalExistencias : 0, 
    });
  };
  consultarPrecios = () => {
    this.setState({ loading: true });
    axios
      .post(
        "empresas/selectPrecios",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.status === 200) {
          this.setState({ listaDePrecios: res.data });
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Error al obtener los precios");
      });
  };

  consultarInsumo = (id) => {
    this.setState({ loading: true });
    axios
      .post(
        "insumos/datosVisualInsumo",
        { empresaId: this.props.empresaId, insumoId: id },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const data = res.data.data || {};

          let unidadSafe = "N/A";
          if (typeof data.unidad === "string") unidadSafe = data.unidad;
          else if (data.unidad && data.unidad.nombre)
            unidadSafe = data.unidad.nombre;
          else if (data.unidadNombre) unidadSafe = data.unidadNombre;

          const impuestos = Array.isArray(data.impuestos) ? data.impuestos : [];

          const costo = Number(data.costo) || 0;
          const precioLista = Number(data.precioLista) || 0;
          const porcentajeLista = Number(data.porcentajeLista) || 0;
          const calcularPreciosSobre = !!data.calcularPreciosSobre;

          let historial = Array.isArray(data.historialCostos)
            ? data.historialCostos
            : [];
          historial.sort((a, b) => new Date(b.fecha) - new Date(a.fecha)); //Ordenar por fecha

          const totalesOriginales = this.calcularImpuestosSobreBases(
            precioLista,
            costo,
            impuestos,
          );

          this.setState(
            {
              descripcion: data.descripcion || "",
              descripcionLarga: data.descripcionLarga || "",
              unidad: unidadSafe,
              costo: costo,
              costoOriginal: costo,
              moneda: data.abreviacionMoneda || "MXN",
              precioLista: precioLista,
              impuestos: impuestos,
              calcularPreciosSobre: calcularPreciosSobre,
              atajosPorcentaje: Array.isArray(data.atajosPorcentaje)
                ? data.atajosPorcentaje
                : [],
              porcentajeLista: porcentajeLista,
              porcentaje: porcentajeLista,

              precioListaImpuestos: totalesOriginales.precioConImpuestos,
              costoImpuestos: totalesOriginales.costoConImpuestos,
              totalImpuestosPrecio: totalesOriginales.totalImpuestosPrecio,
              totalImpuestosCosto: totalesOriginales.totalImpuestosCosto,

              historialCostos: historial,
              verHistorialCostos: false,
              fechaCostoSeleccionado: null,
              loading: false,
            },
            this.recalcularTodo,
          );
        } else {
          message.error("Insumo no encontrado o error al cargar detalles");
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Error de conexión al buscar insumo");
        this.setState({ loading: false });
      });
  };

  calcularImpuestosSobreBases = (basePrecio, baseCosto, impuestosFuncion) => {
    let impuestos = impuestosFuncion || this.state.impuestos;
    if (!Array.isArray(impuestos)) impuestos = [];

    let totalPrecio = 0;
    let totalCosto = 0;

    impuestos.forEach((imp) => {
      let impPrecio = 0;
      let impCosto = 0;

      if (imp.tasaCuota === 1) {
        impPrecio = basePrecio * (Number(imp.monto) / 100);
        impCosto = baseCosto * (Number(imp.monto) / 100);
      } else if (imp.tasaCuota === 2) {
        impPrecio = (basePrecio + totalPrecio) * (Number(imp.monto) / 100);
        impCosto = (baseCosto + totalCosto) * (Number(imp.monto) / 100);
      } else if (imp.tasaCuota === 3) {
        const fijo = Number(imp.monto) / (this.props.tipoDeCambio || 1);
        impPrecio = fijo;
        impCosto = fijo;
      } else if (imp.tasaCuota === 5) {
        impPrecio = 0;
        impCosto = 0;
      }

      totalPrecio += impPrecio;
      totalCosto += impCosto;
    });

    return {
      precioConImpuestos: round2Decimals(Number(basePrecio) + totalPrecio),
      costoConImpuestos: round2Decimals(Number(baseCosto) + totalCosto),
      totalImpuestosPrecio: round2Decimals(totalPrecio),
      totalImpuestosCosto: round2Decimals(totalCosto),
    };
  };

  calcularPreciosEmpresa = (porcentaje) => {
    const { costo, calcularPreciosSobre } = this.state;
    const p = Number(porcentaje || 0) / 100;
    let precioCalculado = 0;

    if (calcularPreciosSobre) {
      precioCalculado = round2Decimals(Number(costo || 0) * (1 + p));
    } else {
      const margen = 1 - p;
      if (margen <= 0) {
        precioCalculado = 0;
      } else {
        precioCalculado = round2Decimals(Number(costo || 0) / margen);
      }
    }

    const { precioConImpuestos } = this.calcularImpuestosSobreBases(
      precioCalculado,
      Number(costo || 0),
    );

    return {
      lista: precioCalculado,
      neto: precioConImpuestos,
    };
  };

  recalcularTodo = () => {
    const { porcentaje } = this.state;
    const valores = this.calcularPreciosEmpresa(porcentaje);

    this.setState({
      precioCalculado: valores.lista,
      precioCalculadoConImpuestos: valores.neto,
    });
  };

  onChangePorcentaje = (value) => {
    this.setState({ porcentaje: Number(value || 0) }, this.recalcularTodo);
  };

  setPorcentajeRapido = (p) => {
    this.setState({ porcentaje: p }, this.recalcularTodo);
  };

  switchVerListaPrecios = () => {
    this.setState({ verListaPrecios: !this.state.verListaPrecios });
  };

  switchVerHistorial = () => {
    this.setState({ verHistorialCostos: !this.state.verHistorialCostos });
  };

  formatDate = (isoDate) => {
    if (!isoDate) return "-";
    const date = new Date(isoDate);
    return date.toLocaleDateString("es-MX", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  usarCostoHistorial = (itemHistorial) => {
    const nuevoCosto = Number(itemHistorial.costo) || 0;

    const totales = this.calcularImpuestosSobreBases(
      this.state.precioLista,
      nuevoCosto,
    );

    this.setState(
      {
        costo: nuevoCosto,
        costoImpuestos: totales.costoConImpuestos,
        fechaCostoSeleccionado: itemHistorial.fecha,
      },
      () => {
        this.recalcularTodo();
        message.success("Calculadora actualizada con costo histórico");
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    );
  };

  restaurarCostoOriginal = () => {
    const costoOriginal = this.state.costoOriginal;

    const totales = this.calcularImpuestosSobreBases(
      this.state.precioLista,
      costoOriginal,
    );

    this.setState(
      {
        costo: costoOriginal,
        costoImpuestos: totales.costoConImpuestos,
        fechaCostoSeleccionado: null,
      },
      () => {
        this.recalcularTodo();
        message.info("Costo restaurado al valor actual");
      },
    );
  };

  aplicarPorcentajeLista = (p) => {
    this.setState({ porcentaje: p }, () => {
      this.recalcularTodo();
      message.success(`Margen del ${p}% aplicado a la calculadora`);
    });
  };

  async consultarExistencias() {
    this.setState({ loadingExistencias: true })
    await axios
      .post(
        "insumos/datosExistencias",
        { empresaId: this.props.empresaId, insumoId: this.state.insumoId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const existencias = res.data.existencias; 
          const totalExistencias = existencias.reduce(
            (acc, ex) => acc + (ex.cantidad || 0),
            0
          );
          this.setState({ loadingExistencias: false, existencias: res.data.existencias, totalExistencias: totalExistencias })
        } else {
          this.setState({ loadingExistencias: false })
          message.warning('No se pudo cargar los datos de existencias')
        }
      });
  }

  switchVerExistencias = () => {
    this.setState({ verExistencias: !this.state.verExistencias });
  };

  render() {
    const {
      loading,
      insumoId,
      descripcion,
      descripcionLarga,
      unidad,
      costo,
      costoOriginal,
      costoImpuestos,
      moneda,
      impuestos,
      calcularPreciosSobre,
      porcentaje,
      precioCalculado,
      precioCalculadoConImpuestos,
      listaDePrecios,
      verListaPrecios,
      historialCostos,
      verHistorialCostos,
      fechaCostoSeleccionado,
    } = this.state;

    const { headersToken, empresaId } = this.props;
    const etiquetaBase = !calcularPreciosSobre
      ? "Costo Base"
      : "venta (precio lista)";

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Cotización por Insumo"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            borderRadius: 6,
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />

        <div style={{ paddingTop: 0 }}>
          <Card
            bordered={false}
            style={{
              minHeight: "80vh",
              borderRadius: 6,
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
            bodyStyle={{ padding: 24 }}
          >
            <Spin spinning={loading}>
              <div
                style={{
                  marginBottom: 30,
                  maxWidth: 800,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                {!this.state.insumoId && (
                  <Text
                    type="secondary"
                    style={{ display: "block", marginBottom: 5 }}
                  >
                    Buscar insumo para comenzar:
                  </Text>
                )}
                <SelectInsumosItem
                  onChange={this.handleInsumoChange}
                  value={insumoId}
                  headersToken={headersToken}
                  empresaId={empresaId}
                  tiposInsumos="venta"
                  placeholder="Nombre, código o descripción..."
                  width="100%"
                  size="large"
                />
              </div>

              <Divider />

              {!descripcion ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "300px",
                    flexDirection: "column",
                  }}
                >
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <span style={{ color: "#bfbfbf" }}>
                        Seleccione un insumo en la barra superior para ver la
                        cotización
                      </span>
                    }
                  />
                </div>
              ) : (
                <>
                  <Row gutter={[24, 24]}>
                    <Col xs={24} lg={11}>
                      <Title
                        level={4}
                        style={{ marginBottom: 20, color: "#595959" }}
                      >
                        Detalles del Producto
                      </Title>
                      <Descriptions
                        bordered
                        size="small"
                        column={1}
                        layout="horizontal"
                        labelStyle={{ width: "140px", fontWeight: 600 }}
                      >
                        <Descriptions.Item label="Descripción">
                          <strong>{descripcion || "-"}</strong>
                        </Descriptions.Item>
                        <Descriptions.Item label="Unidad">
                          <Tag color="blue">{unidad}</Tag>
                        </Descriptions.Item>
                        <Descriptions.Item label="Descripción Larga">
                          <Text type="secondary" style={{ fontSize: 12 }}>
                            {descripcionLarga || "-"}
                          </Text>
                        </Descriptions.Item>

                        <Descriptions.Item label="Costo">
                          <div style={{ width: "100%" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 16,
                              }}
                            >
                              <div style={{ flex: 1 }}>
                                <Text
                                  type="secondary"
                                  style={{
                                    fontSize: 12,
                                    display: "block",
                                    marginBottom: 2,
                                  }}
                                >
                                  Base {fechaCostoSeleccionado ? "(Hist.)" : ""}
                                  :
                                </Text>
                                <Text
                                  style={{
                                    fontSize: 15,
                                    color: fechaCostoSeleccionado
                                      ? "#722ed1"
                                      : "inherit",
                                  }}
                                >
                                  {dineroDisabledMask(costo)}
                                  <EtiquetaMoneda moneda={moneda} />
                                </Text>
                              </div>
                              <div style={{ flex: 1 }}>
                                <Text
                                  type="secondary"
                                  style={{
                                    fontSize: 12,
                                    display: "block",
                                    marginBottom: 2,
                                  }}
                                >
                                  Neto:
                                </Text>
                                <Text
                                  strong
                                  style={{
                                    fontSize: 15,
                                    color: fechaCostoSeleccionado
                                      ? "#722ed1"
                                      : "inherit",
                                  }}
                                >
                                  {dineroDisabledMask(costoImpuestos)}
                                  <EtiquetaMoneda moneda={moneda} />
                                </Text>
                              </div>
                            </div>

                            {fechaCostoSeleccionado && (
                              <div
                                style={{
                                  marginTop: 8,
                                  paddingTop: 8,
                                  borderTop: "1px dashed #f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                              >
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                  Costo Actual Real:
                                </Text>
                                <Text
                                  delete
                                  type="secondary"
                                  style={{ fontSize: 13 }}
                                >
                                  {dineroDisabledMask(costoOriginal)}
                                </Text>
                                <EtiquetaMoneda
                                  moneda={moneda}
                                  style={{ marginLeft: 0 }}
                                />
                                <Tag
                                  style={{
                                    fontSize: 10,
                                    margin: 0,
                                    border: 0,
                                    backgroundColor: "rgba(0,0,0,0.02)",
                                  }}
                                >
                                  Diferencia:{" "}
                                  {round2Decimals(costo - costoOriginal)}
                                </Tag>
                              </div>
                            )}
                          </div>
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                              }}
                            >
                              <span style={{ fontWeight: 600, fontSize: 14 }}>
                                Lista de Precios
                              </span>
                              {listaDePrecios && listaDePrecios.length > 0 && (
                                <Button
                                  type="text"
                                  size="small"
                                  icon={
                                    verListaPrecios ? (
                                      <EyeInvisibleOutlined />
                                    ) : (
                                      <EyeOutlined />
                                    )
                                  }
                                  onClick={this.switchVerListaPrecios}
                                  style={{ padding: "0 4px", height: 20 }}
                                />
                              )}
                            </div>
                          }
                        >
                          {listaDePrecios && listaDePrecios.length > 0 ? (
                            verListaPrecios ? (
                              <div style={{ margin: "-8px 0" }}>
                                {listaDePrecios.map((item, index) => {
                                  const valores = this.calcularPreciosEmpresa(
                                    item.porcentaje,
                                  );
                                  const isSelected =
                                    porcentaje === item.porcentaje;

                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        padding: "12px 0",
                                        borderBottom:
                                          index === listaDePrecios.length - 1
                                            ? "none"
                                            : "1px solid #f0f0f0",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          marginBottom: 8,
                                        }}
                                      >
                                        <Text strong style={{ fontSize: 14 }}>
                                          {"Precio " + item.nombre}
                                        </Text>

                                        <div
                                          style={{
                                            display: "flex",
                                            gap: 8,
                                            alignItems: "center",
                                          }}
                                        >
                                          <Tag
                                            color="blue"
                                            style={{ fontSize: 12, margin: 0 }}
                                          >
                                            {item.porcentaje}%
                                          </Tag>

                                          {isSelected ? (
                                            <Tooltip title="Actualmente en calculadora">
                                              <CheckCircleFilled
                                                style={{ color: "#1890ff" }}
                                              />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip title="Usar este margen">
                                              <Button
                                                size="small"
                                                type="text"
                                                icon={<CalculatorOutlined />}
                                                onClick={() =>
                                                  this.aplicarPorcentajeLista(
                                                    item.porcentaje,
                                                  )
                                                }
                                              />
                                            </Tooltip>
                                          )}
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          gap: 16,
                                        }}
                                      >
                                        <div style={{ flex: 1 }}>
                                          <Text
                                            type="secondary"
                                            style={{
                                              fontSize: 12,
                                              display: "block",
                                              marginBottom: 2,
                                            }}
                                          >
                                            Precio Lista
                                          </Text>
                                          <Text
                                            strong
                                            style={{
                                              fontSize: 15,
                                              color: "#1890ff",
                                            }}
                                          >
                                            {dineroDisabledMask(valores.lista)}
                                            <EtiquetaMoneda moneda={moneda} />
                                          </Text>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                          <Text
                                            type="secondary"
                                            style={{
                                              fontSize: 12,
                                              display: "block",
                                              marginBottom: 2,
                                            }}
                                          >
                                            Precio Neto
                                          </Text>
                                          <Text
                                            strong
                                            style={{
                                              fontSize: 15,
                                              color: "#52c41a",
                                            }}
                                          >
                                            {dineroDisabledMask(valores.neto)}
                                            <EtiquetaMoneda moneda={moneda} />
                                          </Text>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <Text
                                type="secondary"
                                style={{ fontSize: 13, fontStyle: "italic" }}
                              >
                                {listaDePrecios.length} precio
                                {listaDePrecios.length !== 1 ? "s" : ""}{" "}
                                configurado
                                {listaDePrecios.length !== 1 ? "s" : ""} (Click
                                en el ícono para mostrar)
                              </Text>
                            )
                          ) : (
                            <Text
                              type="secondary"
                              style={{ fontSize: 12, fontStyle: "italic" }}
                            >
                              Sin precios configurados
                            </Text>
                          )}
                        </Descriptions.Item>
                      </Descriptions>

                      <div style={{ marginTop: 20 }}>
                        <Text
                          type="secondary"
                          style={{ display: "block", marginBottom: 10 }}
                        >
                          Impuestos Configurados:
                        </Text>
                        <Card size="small" bodyStyle={{ padding: 0 }}>
                          <List
                            dataSource={
                              Array.isArray(impuestos) ? impuestos : []
                            }
                            locale={{ emptyText: "Sin impuestos" }}
                            renderItem={(imp, idx) => {
                              let tagText = "";
                              if (imp.tasaCuota === 1)
                                tagText = `Porcentual (base) ${imp.monto}%`;
                              else if (imp.tasaCuota === 2)
                                tagText = `Porcentual (acumulado) ${imp.monto}%`;
                              else if (imp.tasaCuota === 3)
                                tagText = `Monto fijo ${round2Decimals(
                                  imp.monto / (this.props.tipoDeCambio || 1),
                                )}`;
                              else if (imp.tasaCuota === 5) tagText = "Exento";

                              const nombre =
                                imp.nombre ||
                                imp.clave ||
                                `Impuesto ${idx + 1}`;

                              return (
                                <List.Item
                                  style={{ paddingLeft: 16, paddingRight: 16 }}
                                >
                                  <Space>
                                    <Tag color="cyan">{nombre}</Tag>
                                    <Text type="secondary">{tagText}</Text>
                                  </Space>
                                </List.Item>
                              );
                            }}
                          />
                        </Card>
                      </div>
                    </Col>
                    {/* Barra separadora vertical*/}
                    <Col
                      xs={0}
                      lg={1}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <div
                        style={{
                          width: 1,
                          height: "100%",
                          backgroundColor: "#f0f0f0",
                        }}
                      ></div>
                    </Col>

                    <Col xs={24} lg={11}>
                      <div>
                        <Space align="center" style={{ marginBottom: 16 }}>
                          <Title
                            level={4}
                            style={{ margin: 0, color: "#595959" }}
                          >
                            Calculadora de Margen
                          </Title>
                        </Space>

                        <Text
                          type="secondary"
                          style={{ display: "block", marginBottom: 10 }}
                        >
                          Calculando sobre:
                        </Text>
                        {fechaCostoSeleccionado ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Tag
                              color="purple"
                              //style={{ fontSize: 13, padding: "4px 8px" }}
                            >
                              {"Costo del " +
                                this.formatDate(fechaCostoSeleccionado)}
                            </Tag>
                            <Tooltip title="Regresar al costo base actual">
                              <Button
                                danger
                                ghost
                                size="small"
                                icon={<RollbackOutlined />}
                                onClick={this.restaurarCostoOriginal}
                              >
                                Reset
                              </Button>
                            </Tooltip>
                          </div>
                        ) : (
                          <Tag color="orange">{etiquetaBase}</Tag>
                        )}

                        <div style={{ marginBottom: 20, marginTop: 10 }}>
                          <Text strong>Margen deseado (%):</Text>
                          <InputNumberItem
                            value={porcentaje}
                            onChange={this.onChangePorcentaje}
                            min={-100}
                            max={1000}
                            step={0.5}
                            porcentaje
                            style={{
                              width: "100%",
                              fontSize: 16,
                              marginTop: 5,
                            }}
                            addonAfter="%"
                          />
                        </div>

                        <Space wrap style={{ marginBottom: 30 }}>
                          {normalizarAtajosPorcentaje(
                            this.state.atajosPorcentaje
                          ).map((p) => (
                            <Button
                              size="small"
                              key={p}
                              onClick={() => this.setPorcentajeRapido(p)}
                            >{`+${p}%`}</Button>
                          ))}
                          <Button
                            size="small"
                            type="dashed"
                            onClick={() => this.setPorcentajeRapido(0)}
                          >
                            Reset
                          </Button>
                        </Space>

                        <Card
                          bordered={false}
                          style={{
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                            borderRadius: 8,
                          }}
                        >
                          <Row gutter={[16, 16]}>
                            <Col span={24}>
                              <Text type="secondary">
                                Precio Calculado (Antes de Impuestos)
                              </Text>
                              <Title
                                level={2}
                                style={{
                                  margin: "5px 0 0 0",
                                  color: "#1890ff",
                                }}
                              >
                                {dineroDisabledMask(precioCalculado)}
                                <EtiquetaMoneda
                                  moneda={moneda}
                                  style={{ fontSize: 14 }}
                                />
                              </Title>
                            </Col>
                            <Divider style={{ margin: "10px 0" }} />
                            <Col span={24}>
                              <Text type="secondary">
                                Precio calculado con impuestos (Neto)
                              </Text>
                              <Title
                                level={3}
                                style={{
                                  margin: "5px 0 0 0",
                                  color: "#52c41a",
                                }}
                              >
                                {dineroDisabledMask(
                                  precioCalculadoConImpuestos,
                                )}
                                <EtiquetaMoneda
                                  moneda={moneda}
                                  style={{ fontSize: 13 }}
                                />
                              </Title>
                            </Col>
                          </Row>
                        </Card>
                      </div>
                    </Col>
                  </Row>
                  <div style={{ marginTop: 20 }}>
                    <Divider />
                  <Tabs defaultActiveKey={1} onTabClick={(key) => {
                    if(key === '2'){
                      this.consultarExistencias(); 
                    }
                  }}>
                    <TabPane
                      tab="Historial de Costos"
                      tabKey={1}
                      key={1}
                      forceRender
                    >

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 20,
                        cursor: "pointer",
                      }}
                      onClick={this.switchVerHistorial}
                    >
                      <Space>
                        <HistoryOutlined
                          style={{ fontSize: 18, color: "#595959" }}
                        />
                        <Title
                          level={4}
                          style={{ margin: 0, color: "#595959" }}
                        >
                          Historial de Costos
                        </Title>
                        <Tag>{historialCostos.length}</Tag>
                        {/* La moneda va una sola vez aqui y no en cada renglon:
                            Insumo.historialCostos[] no guarda moneda propia, todos los
                            renglones estan en Insumo.monedaId. */}
                        <Tag>Costos en {moneda || "MXN"}</Tag>
                      </Space>
                      <Button
                        type="text"
                        icon={
                          verHistorialCostos ? (
                            <EyeInvisibleOutlined />
                          ) : (
                            <EyeOutlined />
                          )
                        }
                      >
                        {verHistorialCostos ? "Ocultar" : "Mostrar"}
                      </Button>
                    </div>

                    {verHistorialCostos && (
                      <Row>
                        <Col xs={24} lg={11}>
                          {historialCostos.length > 0 ? (
                            <Card
                              bordered={true}
                              style={{
                                borderRadius: 8,
                                borderColor: "#f0f0f0",
                              }}
                              bodyStyle={{ padding: "0 24px" }}
                            >
                              {historialCostos.map((h, idx) => {
                                const isSelected =
                                  fechaCostoSeleccionado === h.fecha;

                                return (
                                  <div
                                    key={h._id || idx}
                                    style={{
                                      padding: "16px 0",
                                      borderBottom:
                                        idx === historialCostos.length - 1
                                          ? "none"
                                          : "1px solid #f0f0f0",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      backgroundColor: isSelected
                                        ? "#f9f0ff"
                                        : "transparent",
                                    }}
                                  >
                                    <div>
                                      <Text
                                        type="secondary"
                                        style={{
                                          fontSize: 12,
                                          display: "block",
                                        }}
                                      >
                                        Fecha de cambio
                                      </Text>
                                      <Text strong>
                                        {this.formatDate(h.fecha)}
                                      </Text>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        gap: 20,
                                        alignItems: "center",
                                      }}
                                    >
                                      <div style={{ textAlign: "right" }}>
                                        <Text
                                          type="secondary"
                                          style={{
                                            fontSize: 12,
                                            display: "block",
                                          }}
                                        >
                                          Costo registrado
                                        </Text>
                                        <div style={{ lineHeight: 1 }}>
                                          <Text
                                            strong
                                            style={{
                                              fontSize: 16,
                                              color: isSelected
                                                ? "#722ed1"
                                                : "#595959",
                                            }}
                                          >
                                            {dineroDisabledMask(h.costo)}
                                          </Text>
                                        </div>
                                      </div>

                                      {/* Contenedor fijo para que los precios se alineen siempre igual */}
                                      <div
                                        style={{
                                          width: 90,
                                          textAlign: "right",
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          alignItems: "center",
                                        }}
                                      >
                                        {isSelected ? (
                                          <Tag
                                            color="purple"
                                            icon={<CheckCircleFilled />}
                                            style={{ margin: 0 }}
                                          >
                                            En uso
                                          </Tag>
                                        ) : (
                                          <Tooltip title="Usar este costo en la calculadora">
                                            <Button
                                              type="dashed"
                                              shape="circle"
                                              icon={<CalculatorOutlined />}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                this.usarCostoHistorial(h);
                                              }}
                                            />
                                          </Tooltip>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </Card>
                          ) : (
                            <Empty description="No hay historial disponible" />
                          )}
                        </Col>
                      </Row>
                    )}

                    </TabPane>
                    <TabPane tab="Existencias" tabKey={2} key={2} forceRender>
                      <Spin spinning={this.state.loadingExistencias}>
                        <div style={{ padding: '10px 0' }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: 20,
                              cursor: "pointer",
                            }}
                            onClick={this.switchVerExistencias}
                          >
                            <Space>
                              <CalculatorOutlined style={{ fontSize: 18, color: "#595959" }} />
                              <Title level={4} style={{ margin: 0, color: "#595959" }}>
                                Existencias por Proyecto
                              </Title>
                              <Tag color="blue">{this.state.totalExistencias}</Tag>
                            </Space>
                            <Button
                              type="text"
                              icon={this.state.verExistencias ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                            >
                              {this.state.verExistencias ? "Ocultar" : "Mostrar"}
                            </Button>
                          </div>

                          {this.state.verExistencias && (
                            <div style={{ overflowX: 'auto' }}>
                              {this.state.existencias.length > 0 ? (
                                <table className="table" style={{ minWidth: "100%" }}>
                                  <thead>
                                    <tr>
                                      <th className="th-border" style={{ width: "40%" }}>Proyecto</th>
                                      <th className="th-border" style={{ width: "20%" }}>Unidad</th>
                                      <th className="th-border" style={{ width: "20%" }}>Cantidad</th>
                                      <th className="th-border" style={{ width: "20%" }}>Estado</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.existencias.map((valueExistencia, index) => (
                                      <tr key={index}>
                                        <td className="td-border" style={{ textAlign: 'left', padding: '8px' }}>
                                          {valueExistencia.proyecto.nombre}
                                        </td>
                                        <td className="td-border" style={{ textAlign: 'center' }}>
                                          {valueExistencia.unidad.nombre}
                                        </td>
                                        <td className="td-border" style={{ textAlign: 'right', paddingRight: '15px' }}>
                                          <strong>{valueExistencia.cantidad}</strong>
                                        </td>
                                        <td className="td-border" style={{ textAlign: 'center' }}>
                                          <Tag color={valueExistencia.estado === 2 ? "blue" : "green"}>
                                            {valueExistencia.estado === 2 ? "Apartado" : "Disponible"}
                                          </Tag>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <Empty description="No se encontraron existencias para este insumo" />
                              )}
                            </div>
                          )}
                        </div>
                      </Spin>
                    </TabPane>
                  </Tabs>
                  </div>
                </>
              )}
            </Spin>
          </Card>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    tipoDeCambio: state.empresa.tipoDeCambio || 1,
    permisoVerCotizaciones:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750925b798d4e0043687244",
      )?.activado,
  };
};

export default connect(mapStateToProps)(CotizadorPorInsumo);
